import { IStrongBoxSwapInfo } from "./strong-box-order"

export interface IStrongBoxUsageContract {
    clusterId: number,
    swapPositions: number[]
}

export interface IStrongBoxUsageListingBase {
    id: number,
    createdByUserId: number,
    createdDate: Date,
    updatedByUserId: number,
    updatedDate: Date,
    swapInfo: IStrongBoxSwapInfo
}

export interface IStrongBoxCenterUsageListing extends IStrongBoxUsageListingBase {
    centerId: number,
    centerName: string,
}

export interface IStrongBoxOpoUsageListing extends IStrongBoxUsageListingBase {
    opoId: number,
    opoName: string,
}

